import { render, staticRenderFns } from "./QuestionsConfiguration.vue?vue&type=template&id=4427d820&scoped=true&"
import script from "./QuestionsConfiguration.vue?vue&type=script&lang=js&"
export * from "./QuestionsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsConfiguration.vue?vue&type=style&index=0&id=4427d820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427d820",
  null
  
)

export default component.exports